import { render, staticRenderFns } from "./InterviewTreeNode.vue?vue&type=template&id=04be067f&scoped=true"
import script from "./InterviewTreeNode.vue?vue&type=script&lang=js"
export * from "./InterviewTreeNode.vue?vue&type=script&lang=js"
import style0 from "./InterviewTreeNode.vue?vue&type=style&index=0&id=04be067f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be067f",
  null
  
)

export default component.exports